import 
{ 
    GET_ALL_UNREAD_NOTIFICATIONS_LOADING,
    GET_ALL_UNREAD_NOTIFICATIONS_DATA,
    GET_ALL_UNREAD_NOTIFICATIONS_FAILED 
} from "./actionTypes";

export const getAllUnreadNotificationLoading = () => {
    return {
        type: GET_ALL_UNREAD_NOTIFICATIONS_LOADING
    }
}

export const getAllUnreadNotificationData = data => {
    return {
        type: GET_ALL_UNREAD_NOTIFICATIONS_DATA,
        payload: data
    }
}

export const getAllUnreadNotificationFailed = message => {
    return {
        type: GET_ALL_UNREAD_NOTIFICATIONS_FAILED,
        payload: message
    }
}